import { getSuggestion } from './action';

export { suggestionReducer } from './reducer';
export { watchSuggestions } from './saga';
export { GET_SUGGESTION, GET_SUGGESTION_SUCCESS } from 'store/suggestions/types';

export const suggestionAction = {
  getSuggestion,
};
